import { Currency } from "@redotech/money/currencies";
import { ReturnSummaryTotalsSchema } from "@redotech/redo-return-core-common/returns/return-totals/types";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** One returned or exchange line on the POS manage-return actions sheet. */
export const PosManageReturnDetailItemSchema = z.object({
  id: z.string(),
  pendingReturnItemId: z.string(),
  imageSrc: z.string(),
  title: z.string(),
  subtitle: z.string().nullable(),
  quantity: z.number(),
  formattedPrice: z.string(),
  price: z.string(),
  itemValue: z.string(),
  currency: createEnum(Currency),
  presentmentCurrency: z.string(),
  exchangeRate: z.number(),
});

/**
 * Display-ready detail for a single return on the POS process/reset sheet:
 * returned products, exchange ("new") items, and summary totals.
 */
export const PosManageReturnDetailViewSchema = z.object({
  currency: createEnum(Currency),
  products: z.array(PosManageReturnDetailItemSchema),
  newItems: z.array(PosManageReturnDetailItemSchema),
  newItemsHeader: z.string(),
  returnedItemsHeader: z.string(),
  summaryFeesHeader: z.string(),
  summaryFeesOrderHeader: z.string(),
  shouldShowSummary: z.boolean(),
  returnTotals: ReturnSummaryTotalsSchema.optional(),
});

export type PosManageReturnDetailItem = z.infer<
  typeof PosManageReturnDetailItemSchema
>;
export type PosManageReturnDetailView = z.infer<
  typeof PosManageReturnDetailViewSchema
>;

export const getPosManageReturnDetailView = {
  name: "getPosManageReturnDetailView" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ view: PosManageReturnDetailViewSchema }),
};
